import { render, staticRenderFns } from "./DialogEditAddress.vue?vue&type=template&id=74781a2f"
import script from "./DialogEditAddress.vue?vue&type=script&lang=js"
export * from "./DialogEditAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports